Vue.use(VueQrcodeReader);

const REAR_CAMERA = { ideal: 'environment' };
const FRONT_CAMERA = { exact: 'user' };

const vm = new Vue({
  el: '#fila-espera-vue',
  data() {
    return {
      facingMode: REAR_CAMERA,
      activeScan: false,
      noStreamApiSupport: false,
      onLoading: false,
      qrCodeInvalido: false,
      falhaConsultaFila: false,
      isLoja: true,
      isRestaurante: false,
      idLoja: '',
      nomeLoja: '',
      tempoEspera: '',
      quantidadePessoas: '',
      numAcompanhantes: '',
      pisosLoja: [],
      telefonesLoja: [],
      camera: {
        video: {
          width: {
            min: 360,
            ideal: 360,
            max: 360,
          },
          height: {
            min: 360,
            ideal: 360,
            max: 360,
          },
        },
      },
    };
  },
  mounted() {
    this.$nextTick(function () {
      localStorage.removeItem('ID_LOJA_FILA_ESPERA');
      localStorage.removeItem('NUM_ACOMP');
      const idLoja = new URLSearchParams(window.location.search).get('idLoja');
      if (idLoja) {
        this.idLoja = idLoja;
        this.onLoading = true;
        this.setarDadosFila(idLoja);
      } else this.activeScan = true;
    });
  },
  methods: {
    switchCamera: function switchCamera() {
      if (this.facingMode === FRONT_CAMERA) {
        this.facingMode = REAR_CAMERA;
      } else {
        this.facingMode = FRONT_CAMERA;
      }
    },
    onDecode: function onDecode(result) {
      let encontrouLoja = false;
      this.onLoading = true;

      if (result) {
        try {
          const url = new URL(result);
          const idLoja = url.searchParams.get('idLoja');
          if (idLoja) {
            this.idLoja = idLoja;
            this.setarDadosFila(idLoja);
            encontrouLoja = true;
          }
        } catch (error) {
          console.log(error);
        }
      }
      if (encontrouLoja) {
        this.qrCodeInvalido = false;
      } else {
        this.qrCodeInvalido = true;
        this.onLoading = false;
      }
    },
    onDetect: async function onDetect(promise) {
      this.onLoading = true;
      try {
        const { imageData, content, location } = await promise;
        if (content != null) this.onDecode(content);
        else {
          this.qrCodeInvalido = true;
          this.onLoading = false;
        }
      } catch (error) {
        this.qrCodeInvalido = true;
        this.onLoading = false;
      }
    },
    onInit: async function onInit(promise) {
      try {
        await promise;
      } catch (error) {
        if (error.name === 'StreamApiNotSupportedError') {
          this.noStreamApiSupport = true;
        }
      }
    },
    setarDadosFila: function setarDadosFila(idLoja) {
      const that = this;
      const urlConsultaFila = '/aliansce/shopping/rest/filadeespera/consultafila/' + idLoja;
      $.getJSON(urlConsultaFila, data => {
        if (data.httpcode === 200) {
          const response = JSON.parse(data.response);

          if (response) {
            that.setarDadosLoja(idLoja, that);
            that.nomeLoja = response.loja;
            that.tempoEspera = new Date(response.tempoEspera * 1000).toISOString().substr(14, 5);
            that.quantidadePessoas = response.tamanhoFila;
          }
          that.activeScan = false;
        } else if (data.httpcode === 400 || data.httpcode === 404) {
          that.qrCodeInvalido = true;
        } else that.falhaConsultaFila = true;
      })
        .fail(() => {
          that.falhaConsultaFila = true;
        })
        .always(() => {
          that.onLoading = false;
        });
    },
    setarDadosLoja: function setarDadosLoja(idLoja, context) {
      $.ajax({
        url: '/lojas_files/lojas.json?paramRandom=' + Math.random(),
        type: 'get',
        async: false,
        success: function success(data) {
          data.forEach((store, index) => {
            const id = store.id;

            if (id == idLoja) {
              const localizacoes = store.pavimento;

              for (var i in localizacoes) context.pisosLoja.push(localizacoes[i]);

              const telefones = store.telefone;

              for (var i in telefones) {
                let telefone = '+55 ';

                const numeroTelefone = telefones[i];

                if (numeroTelefone) {
                  if (numeroTelefone.length == 8)
                    telefone +=
                      numeroTelefone.substring(0, 4) + '-' + numeroTelefone.substring(4, 8);
                  else if (numeroTelefone.length == 9)
                    telefone +=
                      numeroTelefone.substring(0, 5) + '-' + numeroTelefone.substring(5, 9);
                  else telefone += numeroTelefone;
                }

                context.telefonesLoja.push(telefone);
              }

              if (store.categoria) {
                store.categoria.forEach(itemSegmento => {
                  if (itemSegmento == 'ALIMENTAÇÃO') context.isRestaurante = true;
                });
              }
            }
          });
        },
      });
    },
    sendToGA: function sendToGA(nomeLoja) {
      if (typeof gtag === 'function') {
        gtag('event', 'Entrar na fila', {
          event_category: 'Fila de espera',
          event_label: nomeLoja,
        });
      }
    },
    enviaParaLogin: function enviaParaLogin() {
      this.sendToGA(this.nomeLoja);
      localStorage.setItem('ID_LOJA_FILA_ESPERA', this.idLoja);
      localStorage.setItem('NUM_ACOMP', this.numAcompanhantes);
      window.location.href = $('#linkMinhaFila').attr('href');
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
});
